export const SAVE_ALL_SUPPLIERS = 'SAVE_ALL_SUPPLIERS'
export const SAVE_SUPPLIER = 'SAVE_SUPPLIER'
